// @ts-strict-ignore
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { environment } from '@env/environment';

@Component({
    // tslint:disable-next-line: component-selector
    selector: '[tmnz-row-header]',
    templateUrl: './row-header.component.html',
    styleUrls: ['./row-header.component.scss'],
    standalone: false
})
export class RowHeaderComponent {
  public environment = environment;
  private NUM_OF_STATIC_COLS = 1;
  @Output() rowChecked = new EventEmitter<{ header: any; item: any; bulkMode: boolean }>();
  @Input() header: any;
  @Input() headersHaveItems: boolean;
  @Input()
  set columnConfig(columnConfig: Array<any>) {
    /* Various component setup */
    this._columnConfig = columnConfig;
    this.columnWidth = 100 / (columnConfig.length + this.NUM_OF_STATIC_COLS);
  }

  @Input() actions: object;
  // tslint:disable: variable-name
  public _columnConfig: any;
  public columnWidth: number;

  toggleItems() {
    this.header.showItems = !this.header.showItems;
  }

  markItemSelected(header, item) {
    item.checked = !item.checked;
    this.rowChecked.emit({ header, item, bulkMode: false });
  }

  /**
   * Used on tables that have no subtables
   */
  markHeaderSelected(header) {
    this.rowChecked.emit({ header, item: null, bulkMode: false });
    header.checked = !header.checked;
  }

  markAll(headerChecked, header) {
    header.items.forEach((item) => {
      if (item.checked !== headerChecked && item.isMatch) {
        this.markItemSelected(header, item);
      }
    });
  }

  onHeaderCheckClick($event, header) {
    const headerChecked = $event.target.checked;

    if (this.headersHaveItems) {
      this.markAll(headerChecked, header);
    } else {
      this.markHeaderSelected(header);
    }
  }

  // TODO: refactor filterable table to allow for no sub-tables.
  // Remove some dependency on run-management
  allChecked(header) {
    if (this.headersHaveItems) {
      return header.items.every((item) => {
        if (item.isMatch && !item.checked) {
          return false;
        }
        return true;
      });
    } else {
      return !!header.checked;
    }
  }
}
